/**
   * @arg {string} metaType
   * @arg {string | null} metaName
   */
export function getMetaContent(metaType, metaName) {
  if (!metaType) metaType = "name";
  const metas = document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute(metaType) === metaName) {
      return metas[i].getAttribute('content');
    }
  }
  return '';
}